<template>
  <div class="page-home-categories">
    <CategoryWidget
      v-for="({ id }, i) in items"
      :key="i"
      :category-id="id"
      class="mt-3"
    />
  </div>
</template>

<script>
import CategoryWidget from "@/components/widgets/Category.vue";

const _config = {
  mod: "articles-categories",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod)
        .list.filter(({ featured_home_top }) => featured_home_top === 1)
        .slice(0, this.count)
        .sort((a, b) => a.order - b.order);
    },

    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    count() {
      if (this.xs) return 3;
      else if (this.md) return 2;
      else return 3;
    },
  },
  components: {
    CategoryWidget,
  },
};
</script>

<style>
.page-home-categories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

@media screen and (max-width: 1264px) {
  .page-home-categories {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .page-home-categories {
    grid-template-columns: 1fr;
  }
}
</style>
